import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import throttle from 'lodash/throttle';
var InfiniteScrollZone = observer(_class = /*#__PURE__*/function (_React$Component) {
  function InfiniteScrollZone() {
    var _this;
    _classCallCheck(this, InfiniteScrollZone);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InfiniteScrollZone, [].concat(args));
    _this.onScroll = function () {
      _this.checkBounds();
    };
    _this.checkBounds = throttle(function () {
      var provider = _this.provider;
      if (!_this.node || !provider.active || !provider.more) {
        return;
      }
      var containerH = window.innerHeight || window.documentElement.clientHeight;
      var rect = _this.node.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      // Partially visible elements return true:
      var visible = elemTop < containerH && elemBottom >= 0;
      if (visible) {
        provider.more();
      }
    }, 100);
    return _this;
  }
  _inherits(InfiniteScrollZone, _React$Component);
  return _createClass(InfiniteScrollZone, [{
    key: "provider",
    get: function get() {
      return this.props.scrollProvider || {
        isDone: this.props.isDone,
        active: this.props.active,
        more: this.props.more
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.onScroll);
      this._interval = setInterval(this.checkBounds, 300);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
      clearInterval(this._interval);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var provider = this.provider;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(n) {
          _this2.node = n;
        }
      }, this.props.children({
        isDone: provider.isDone,
        active: provider.active
      }));
    }
  }]);
}(React.Component)) || _class;
export { InfiniteScrollZone as default };
//# sourceMappingURL=index.js.map
